// extracted by mini-css-extract-plugin
export var dropdownIcon = "_ot-6";
export var imgContainer = "_ot-3";
export var menuIcon = "_ot-5";
export var pillWrapper = "_ot-2";
export var pillsContainer = "_ot-1";
export var subscriptionCard = "_ot-0";
export var subscriptionLogo = "_ot-4";